import { ReactNode } from 'react';

import { Plan } from '../../Dashboard.types';
import { PaymentPlanCard } from '../PaymentPlanCard/PaymentPlanCard';

export const SelectedView = ({
  children,
  plan,
}: {
  children: ReactNode;
  plan: Plan;
}) => {
  return (
    <section className="flex flex-col gap-l">
      {plan && (
        <div className="border-b-[1px] border-structure-80 bg-structure-100">
          <PaymentPlanCard
            created={plan.payLink.created}
            funded_at={plan.payLink.funded_at}
            reference={plan.payLink.reference}
            sellerName={plan.payLink.seller_trading_name}
            amount={plan.payLink.amount}
            status={plan.status}
          />
        </div>
      )}
      {children}
    </section>
  );
};
